<template>
    <v-card color="" elevation="0" class="px-4">
        <v-divider></v-divider>
        <div class="d-flex pt-3 pb-7 mt-2">
            <v-text-field style="flex: 0 1 300px" v-model="search" append-icon="mdi-magnify" outlined
                :label="$t('products.packages.search')" single-line dense hide-details></v-text-field>
            <v-spacer></v-spacer>
            <div class="d-flex">
                <v-tooltip v-if="!enabled" bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="enabled = !enabled" v-bind="attrs" v-on="on" class="py-5 ml2"
                            elevation="0"><v-icon>mdi-sort</v-icon></v-btn>
                    </template>
                    <span>{{ $t('products.packages.changeSort') }}</span>
                </v-tooltip>
                <v-btn v-else @click="updateOrder()" class="py-5 ml2" color="success" elevation="0">{{
                    $t('common.save') }}</v-btn>

                <v-btn color="success" @click="add()" class="py-5 ml-2" elevation="0">{{ $t('common.add') }}</v-btn>
            </div>

        </div>

        <v-card outlined>

            <v-data-table hide-default-footer disable-pagination sort-by="sortIndex" item-key="id" :sort-desc="false"
                :headers="headers" :items="documents" :items-per-page="10" :search="search" class="elevation-1">
                <template v-slot:body="props">
                    <draggable :list="props.items" tag="tbody" :disabled="!enabled" :move="onMove"
                        @end="result = props.items">
                        <tr v-for="(item, index) in props.items" :key="index">
                            <!-- <td>{{ item.sortIndex + 1 }}</td> -->
                            <td><v-avatar size="38">
                                    <v-img width="38" height="38" :src="item.image"></v-img>
                                </v-avatar></td>
                            <td>{{ item.name }}</td>
                            <td>{{ joinItems(item.coverage) }} </td>
                            <td> {{ $n(item.finalPrice, 'currency') }} </td>
                            <!-- <td> {{ $n(item.cpm, 'currency') }} </td> -->
                            <td> {{ joinItems(item.stores) }} </td>
                            <td><template v-if="item.dueDate">{{ item.dueDate | dateCompact }}</template></td>
                            <td> {{ item.asus.length }} </td>
                            <td><v-chip label small v-if="item.inHome && item.inHome" color="success">{{
                                $t('common.active') }}</v-chip>
                                <v-chip label small v-else>{{ $t('products.packages.inactive') }}</v-chip>
                            </td>
                            <td><v-chip label small v-if="item.featured && item.featured" color="success">{{
                                $t('common.active') }}</v-chip>
                                <v-chip label small v-else>{{ $t('products.packages.inactive') }}</v-chip>
                            </td>
                            <td><v-chip label small v-if="item.status && item.status == 'published'" color="success">{{
                                $t('common.active') }}</v-chip>
                                <v-chip label small v-else>{{ $t('products.packages.inactive') }}</v-chip>
                            </td>
                            <td>{{ item.updatedOn | dateTimeS }}</td>
                            <td align="right">
                                <v-btn icon color="error" :disabled="anyOrderWithThisPack" @click="selectedItemToRemove(item)">
                                    <v-icon>mdi-trash-can-outline</v-icon>
                                </v-btn>
                                <v-btn class="mr-1" icon @click="editItem(item)"><v-icon
                                        small>mdi-pencil-outline</v-icon></v-btn>
                                <v-btn @click="replicate(item)" icon class="mr-1"><v-icon
                                        small>mdi-content-copy</v-icon></v-btn>
                                <v-btn v-if="masterStore.id == 'gruporpp'" icon
                                    :href="`https://publiya.pe/paquete/${item.id}/${item.name}`" target="_blank"><v-icon
                                        small>mdi-open-in-new</v-icon></v-btn>
                                <v-btn v-else icon
                                    :href="`https://${item.stores[0]}.themediatrade.com/package/${item.id}/${item.name}`"
                                    target="_blank"><v-icon small>mdi-open-in-new</v-icon></v-btn>

                            </td>
                        </tr>

                        <v-dialog v-model="removePack" width="540">
                            <v-card class="mx-auto">
                                <v-card-title>
                                    <div class="d-flex">
                                        <span>Tem certeza que deseja remover este pacote permanentemente?</span>
                                    </div>
                                </v-card-title>
                                <v-card-text>
                                    <div class="d-flex">
                                        <v-spacer></v-spacer>
                                        <v-btn @click="removePack = false" text>{{ $t('common.cancel') }}</v-btn>
                                        <v-btn @click="removeSelectedPack()" color="error" elevation="0">{{ $t('common.remove')
                                            }}</v-btn>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-dialog>



                        <!-- <template v-slot:[`item.image`]="{ item }">
                    <v-avatar size="38">
                        <v-img width="38" height="38" :src="item.image"></v-img>
                    </v-avatar>
                </template>
               
                <template v-slot:[`item.dueDate`]="{ item }">
                    <template v-if="item.dueDate">
                        {{ item.dueDate | dateCompact }}
                    </template>
                    <template v-else>{{ $t('products.packages.dontValidity') }}</template>
                </template>
                <template v-slot:[`item.finalPrice`]="{ item }">
                    {{ $n(item.finalPrice, 'currency') }}
                </template>
                <template v-slot:[`item.cpm`]="{ item }">
                    {{ $n(item.cpm, 'currency') }}
                </template>
                <template v-slot:[`item.asus`]="{ item }">
                    {{ item.asus.length }}
                </template>
                <template v-slot:[`item.status`]="{ item }">
                    <v-chip label small v-if="item.status && item.status == 'published'"
                        color="success">{{ $t('common.active') }}</v-chip>
                    <v-chip label small v-else>{{ $t('products.packages.inactive') }}</v-chip>
                </template>
                <template v-slot:[`item.id`]="{ item }">
                    <v-btn icon small @click="editItem(item)"><v-icon>mdi-pencil-outline</v-icon></v-btn>
                </template> -->

                    </draggable>
                </template>

            </v-data-table>
        </v-card>

        <v-dialog width="1366" v-model="show">
            <PackageForm v-if="show" :show="show" :snap="snap" @show-form="show = $event"
                @reload-documents="loadDocuments()">
            </PackageForm>
        </v-dialog>
        <v-dialog width="640" v-model="sorter.show">
            <v-card class="mx-auto" v-if="sorter.show">
                <SorterArray :snap="documents"></SorterArray>
            </v-card>
        </v-dialog>

    </v-card>
</template>
<script>
import moment from 'moment'
import config from '@/store/config'
import { mapActions } from 'vuex';
import { mapState } from "vuex";
import { initializeApp } from "firebase/app";

// import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import draggable from 'vuedraggable'

import { doc, updateDoc, getFirestore, collection, query, getDocs, deleteDoc } from "firebase/firestore";
import PackageForm from './PackageForm.vue';
import SorterArray from '../customize/SorterArray.vue';
// import Sortable from 'sortablejs/modular/sortable.complete.esm.js';
export default {
    name: "PackagesList",
    components: { PackageForm, SorterArray, draggable },
    data() {
        return {
            selectedId: null,
            removePack: false,
            result: [],
            newOrder: [],
            enabled: false,
            reRender: 0,
            dragNdrop: [],
            sorter: {
                show: false
            },
            loading: true,
            show: false,
            snap: null,
            search: this.$route.query.q ? this.$route.query.q : "",
            documents: [],

        };
    },
    mounted() {
        this.loadDocuments();
    },
    watch: {
        "$route.params.tab"(value) {
            if (value != 1)
                this.search = this.$route.query.q ? this.$route.query.q : "";
        }
    },

    computed: {
        ...mapState("groupStores", [
            "masterStore",
        ]),
        headers() {
            return [
                // {
                //     text: "index",
                //     sortable: true,
                //     value: "sortIndex"
                // },
                {
                    text: "",
                    align: "start",
                    sortable: true,
                    value: "image",
                },
                {
                    text: this.$t('products.packages.name'),
                    align: "start",
                    sortable: false,
                    value: "name",
                },
                {
                    text: this.$t('products.packages.coverage'), value: "coverage", sortable: false,
                },
                {
                    text: this.$t('products.packages.finalPrice'), value: "finalPrice", sortable: false,
                },
                // {
                //     text: this.$t('products.packages.CPM'), value: "cpm", sortable: false,
                // },
                {
                    text: this.$t('products.packages.stores'), value: "storesText", sortable: false,
                },
                {
                    text: this.$t('products.packages.validate'), value: "dueDate", sortable: false,
                },
                {
                    text: this.$t('products.packages.asus'), value: "asus", sortable: false,
                },
                {
                    text: this.$t('products.packages.inHomeLabel'), value: "inHomeLabel", sortable: false,
                },
                {
                    text: this.$t('products.packages.featuredLabel'), value: "featuredLabel", sortable: false,
                },
                {
                    text: this.$t('products.packages.status'), value: "status", sortable: false,
                },
                {
                    text: 'Atualizado em', value: 'updatedOn', sortable: false
                },
                {
                    text: "", value: "id", sortable: false,
                }
                // { text: "", value: "actions", sortable: false }
            ]
        }
    },
    methods: {

        ...mapActions("snackbar", ["showSnack"]),
        onMove({ relatedContext, draggedContext }) {
            console.log('relatedContext', relatedContext)
            console.log('draggedContext', draggedContext)
            const relatedElement = relatedContext.element;
            const draggedElement = draggedContext.element;

            return (
                (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
            )
        },
        onEnd(e) {
            console.log('Event', e)
            const res = []
            e.relatedContext.list.forEach((item) => {
                res.push(item.id)
            })
            console.log('res', res)
            this.newOrder = res
        },
        updateOrder() {
            const res = []
            this.result.forEach((item) => {
                res.push(item.id)
            })
            const firebase = initializeApp(config);
            const db = getFirestore(firebase);

            const masterRef = doc(db, "stores", this.masterStore.id);
            updateDoc(masterRef, {
                "packagesSorter": res
            }).then(() => {
                this.showSnack({
                    text: this.$t("common.messages.sortSaved"),
                    color: "success",
                    timeout: 3800,
                    icon: "mdi-check",
                });

                this.enabled = !this.enabled
            })
        },
        joinItems(items) {
            if (Array.isArray(items)) {
                return items.join(', ')
            }
            else
                return ''
        },
        editItem(item) {
            console.log('snap to edit', item)
            this.snap = JSON.parse(JSON.stringify(item))
            this.show = true
        },
        replicate(item) {
            this.snap = JSON.parse(JSON.stringify(item))
            this.snap.id = null
            this.show = true
        },
        add() {
            this.snap = null
            this.show = true
        },
        initSortable() {
            let table = document.querySelector("tbody");
            const _self = this;
            // this way we avoid data binding
            _self.dragNdrop = JSON.parse(JSON.stringify(_self.documents));

            Sortable.create(table, {
                onEnd({
                    newIndex,
                    oldIndex
                }) {

                    _self.dragNdrop.splice(
                        newIndex,
                        0,
                        ..._self.dragNdrop.splice(oldIndex, 1)
                    );
                    console.log('_self.dragNdrop', _self.dragNdrop);
                }
            });
        },
        loadDocuments() {
            let sortIndex = []
            if (this.masterStore.hasOwnProperty('packagesSorter')) {
                sortIndex = this.masterStore.packagesSorter
            }
            console.log('sortIndex', sortIndex)
            this.show = false
            this.loading = true;
            const firebase = initializeApp(config);
            const db = getFirestore(firebase);
            const q = query(collection(db, "packages"));
            const querySnapshot = getDocs(q);
            const documents = [];
            querySnapshot.then((docs) => {
                docs.forEach((doc, i) => {
                    // format
                    let format = doc.data();
                    if (!this.$root.auth.profile.whitelabelId || format.stores.includes(this.$root.auth.profile.whitelabelId)) {
                        if (!sortIndex.length) {
                            format.sortIndex = i
                        }
                        else {
                            format.sortIndex = 1000
                            sortIndex.forEach((item, index) => {
                                if (item == format.id) {
                                    console.log(`O item ${item} é index ${index}`)
                                    format.sortIndex = index
                                }
                            })
                        }
                        format.storesText = format.hasOwnProperty('stores') && format.stores.length ? format.stores.join(', ') : ''
                        format.updatedOn = format.hasOwnProperty('updatedOn') && format.updatedOn ? format.updatedOn : ''
                        documents.push(format);
                    }
                });

                this.documents = documents.sort((p1, p2) => (p1.sortIndex > p2.sortIndex) ? 1 : (p1.sortIndex < p2.sortIndex) ? -1 : 0);

                this.documents = documents;
                this.loading = false;
                // this.initSortable()
            });
        },

        removeSelectedPack() {
            const firebase = initializeApp(config)
            const db = getFirestore(firebase);
            deleteDoc(doc(db, "packages", this.selectedId)).then(() => {
                this.showSnack({
                    text: this.$t("package.removed"),
                    color: "success",
                    timeout: 3800,
                    icon: "mdi-check",
                });
                this.$forceUpdate()

                this.removePack = false
                this.loadDocuments()
            })
        },

        selectedItemToRemove(item) {
            this.selectedId = item.id
            this.removePack = true
        }
    },
}
</script>

<style lang="scss" scoped></style>